import React from 'react';
import {ReactDatePickerProps} from 'react-datepicker';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputDate from '../../../../common/components/ui/InputDate';
import styles from './FieldStartDate.module.scss';

const FieldStartDate = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-startDate',
    defaultMessage: 'Start date'
  });
  const placeholderText = intl.formatMessage({
    id: 'datepicker-placeholder-date',
    defaultMessage: 'Select date'
  });
  const [
    field,
    meta,
    helpers
  ] = useField({name: 'startDate'});

  const handleChange: ReactDatePickerProps<any, false>['onChange']  = (date) => {
    helpers.setValue(date);
  };

  const handleReset = () => {
    helpers.setValue(null);
  };

  return (
    <InputDate
      {...field}
      {...meta}
      id={field.name}
      startDate={field.value}
      minDate={new Date()}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      placeholderText={placeholderText}
      onChange={handleChange}
      onReset={handleReset}
      error={meta.error}
    />
  );
};

export default FieldStartDate;
